import React, { useState, useEffect } from "react";
import { Container, Modal, Button, Spinner } from "react-bootstrap";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";
import brandLogo from "../static/ssie_logo.png";

import ECU_Logo from "../static/logos/ECU.png";
import VU_Logo from "../static/logos/VU.png";
import RMTI_Logo from "../static/logos/RMIT.png";
import UOW_Logo from "../static/logos/UOW.png";
import CQU_Logo from "../static/logos/CQU.png";
import ACU_Logo from "../static/logos/ACU.svg";
import LaTrobe_Logo from "../static/logos/La Trobe.png";
import SSIE_Logo from "../static/ssie_logo.png";
import Navitas_Logo from "../static/logos/navitas.jpeg";
import ECC_Logo from "../static/logos/ECC.png";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YoutubeIcon from "@mui/icons-material/YouTube";
import LanguageIcon from "@mui/icons-material/Language";
import CT_Logo from "../static/default-profile.png";

export default function CreateEnquiry() {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [serverMessage, setServerMessage] = useState("");

    const [errors, setErrors] = useState({});
    const [focused, setFocused] = useState("");

    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        qualification: "",
        date_of_birth: "",
        source: "Exhibition",
    });

    useEffect(() => {
        if (localStorage.getItem("exhibition_submitted") === "true") {
            setServerMessage("You have already submitted your registration.");
            setShowModal(true);
        }
    }, []);

    const greenStart = "#2ECC71";
    const greenMid = "#1AAE88";
    const greenEnd = "#0E8FA0";
    const charcoal = "#4A4A4A";

    // PAGE — Samsung safe
    const page = {
        minHeight: "100vh",
        padding: "36px 18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        background: "#F9FBFE",
        fontFamily: "'Inter', sans-serif",
        overflowX: "hidden"
    };

    // CARD — no blur, no drop-shadow effects
    const card = {
        width: "100%",
        maxWidth: "900px",
        background: "#FFFFFF",
        borderRadius: "14px",
        padding: "36px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        zIndex: 2,
    };

    const topLogoWrap = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "12px",
    };

    const topLogo = {
        height: "56px",
        objectFit: "contain",
    };

    const heading = {
        fontSize: "26px",
        fontWeight: 800,
        color: charcoal,
        textAlign: "center",
        marginTop: "6px",
        marginBottom: "18px",
    };

    const description = {
        textAlign: "center",
        color: "#55606A",
        marginBottom: "18px",
        fontSize: "14px",
    };

    const fieldLabel = {
        display: "block",
        fontSize: "14px",
        fontWeight: 600,
        color: charcoal,
        marginBottom: "8px",
    };

    const inputBase = {
        width: "100%",
        padding: "12px 14px",
        fontSize: "15px",
        borderRadius: "10px",
        border: "1px solid #E6E9EB",
        background: "#FAFBFC",
        marginBottom: "16px",
        transition: "all 150ms ease",
        boxSizing: "border-box",
    };

    const inputFocused = {
        border: `1px solid ${greenMid}`,
        background: "#FFFFFF",
        boxShadow: `0 0 0 3px rgba(26,174,136,0.25)`
    };

    const errorText = {
        color: "#D04545",
        fontSize: "13px",
        marginTop: "-10px",
        marginBottom: "8px",
    };

    const submitBtn = {
        width: "100%",
        padding: "14px",
        borderRadius: "10px",
        fontWeight: 700,
        fontSize: "16px",
        color: "#FFFFFF",
        background: `linear-gradient(90deg, ${greenStart}, ${greenMid}, ${greenEnd})`,
        border: "none",
        marginTop: "2px"
    };

    const logosStripWrap = {
        margin: "8px 0 20px",
        overflow: "hidden",
        width: "100%",
        borderRadius: "8px",
        padding: "8px 6px",
        background: "linear-gradient(180deg, #f0f8f5, #f9fbfe)",
    };

    const logosInner = {
        display: "inline-flex",
        alignItems: "center",
        gap: "36px",
        animation: "scrollLogos 18s linear infinite"
    };

    const logoImg = {
        height: "46px",
        objectFit: "contain",
    };

    const footerNote = {
        marginTop: "18px",
        fontSize: "13px",
        color: "#6b7680",
        textAlign: "center",
    };

    // VALIDATION
    function validate() {
        const e = {};
        if (!form.first_name.trim()) e.first_name = "First name required";
        if (!form.last_name.trim()) e.last_name = "Last name required";
        if (!form.email.trim()) e.email = "Email required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Invalid email";
        if (!form.phone_number.trim()) e.phone_number = "Phone required";
        if (!form.qualification) e.qualification = "Select qualification";
        if (!form.date_of_birth) e.date_of_birth = "Date of birth required";
        setErrors(e);
        return Object.keys(e).length === 0;
    }

    async function onSubmit(e) {
        e.preventDefault();

        if (localStorage.getItem("exhibition_submitted") === "true") {
            setServerMessage("You have already submitted.");
            setShowModal(true);
            return;
        }

        if (!validate()) return;
        setLoading(true);

        try {
            const res = await fetchWithAuth(`${url}create-exhibition-enquiry`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            await res.json();

            setServerMessage("Thank you for registering!");
            setShowModal(true);

            localStorage.setItem("exhibition_submitted", "true");

            setForm({
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
                qualification: "",
                date_of_birth: "",
                source: "Exhibition",
            });

        } catch {
            setServerMessage("Network error, try again.");
            setShowModal(true);
        }
        setLoading(false);
    }

    const hide = () => {
        setShowModal(false);
        window.location.href = "https://ssie.lk";
    };

    const uniLogos = [
        ECU_Logo, LaTrobe_Logo, CQU_Logo, ACU_Logo,
        RMTI_Logo, VU_Logo, UOW_Logo, SSIE_Logo,
        Navitas_Logo, ECC_Logo
    ];

    return (
        <div style={page}>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    overflow: "hidden",
                    zIndex: 0,
                    pointerEvents: "none",
                }}
            >
                <svg
                    viewBox="0 0 1600 900"
                    preserveAspectRatio="xMidYMid slice"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                >
                    <defs>
                        <linearGradient id="swooshGrad" x1="0" x2="1" y1="0" y2="0">
                            <stop offset="0%" stopColor={greenStart} />
                            <stop offset="55%" stopColor={greenMid} />
                            <stop offset="100%" stopColor={greenEnd} />
                        </linearGradient>
                    </defs>

                    {/* LAYER 1 */}
                    <path
                        d="
                        M0 0 
                        L1600 0 
                        L1600 900 
                        Q1200 750 800 820 
                        Q300 900 0 700 Z
                    "
                        fill="url(#swooshGrad)"
                        opacity="0.80"
                    />

                    {/* LAYER 2 */}
                    <path
                        d="
                        M0 150 
                        Q400 20 900 100 
                        Q1400 180 1600 120 
                        L1600 900 
                        L0 900 Z
                    "
                        fill="url(#swooshGrad)"
                        opacity="0.55"
                    />

                    {/* LAYER 3 */}
                    <path
                        d="
                        M0 300 
                        Q450 180 1000 260 
                        Q1500 340 1600 280 
                        L1600 900 
                        L0 900 Z
                    "
                        fill="url(#swooshGrad)"
                        opacity="0.35"
                    />
                </svg>
            </div>


            <div style={card}>
                <div style={topLogoWrap}>
                    <img src={brandLogo} alt="logo" style={topLogo} />
                </div>

                <div style={heading}>Australia University Admissions Day</div>
                <div style={description}>Quick registration for our admissions event.</div>

                {/* LOGO STRIP */}
                <div style={logosStripWrap}>
                    <div style={logosInner}>
                        {uniLogos.concat(uniLogos).map((src, i) => (
                            <img key={i} src={src} alt="" style={logoImg} />
                        ))}
                    </div>
                </div>

                {/* FORM */}
                <form onSubmit={onSubmit} style={{ opacity: loading ? 0.5 : 1 }}>

                    {/* NAME ROW */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                        <div>
                            <label style={fieldLabel}>Given name</label>
                            <input
                                type="text"
                                value={form.first_name}
                                onChange={(e) => setForm({ ...form, first_name: e.target.value })}
                                onFocus={() => setFocused("first_name")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "first_name" ? inputFocused : {})
                                }}
                            />
                            {errors.first_name && <div style={errorText}>{errors.first_name}</div>}
                        </div>

                        <div>
                            <label style={fieldLabel}>Surname</label>
                            <input
                                type="text"
                                value={form.last_name}
                                onChange={(e) => setForm({ ...form, last_name: e.target.value })}
                                onFocus={() => setFocused("last_name")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "last_name" ? inputFocused : {})
                                }}
                            />
                            {errors.last_name && <div style={errorText}>{errors.last_name}</div>}
                        </div>
                    </div>

                    {/* CONTACT ROW */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                        <div>
                            <label style={fieldLabel}>Phone number</label>
                            <input
                                type="tel"
                                value={form.phone_number}
                                onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
                                onFocus={() => setFocused("phone_number")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "phone_number" ? inputFocused : {})
                                }}
                            />
                            {errors.phone_number && <div style={errorText}>{errors.phone_number}</div>}
                        </div>

                        <div>
                            <label style={fieldLabel}>Email</label>
                            <input
                                type="email"
                                value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                onFocus={() => setFocused("email")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "email" ? inputFocused : {})
                                }}
                            />
                            {errors.email && <div style={errorText}>{errors.email}</div>}
                        </div>
                    </div>

                    {/* DOB / QUALIFICATION */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                        <div>
                            <label style={fieldLabel}>Date of birth</label>
                            <input
                                type="date"
                                value={form.date_of_birth}
                                onChange={(e) => setForm({ ...form, date_of_birth: e.target.value })}
                                onFocus={() => setFocused("date_of_birth")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "date_of_birth" ? inputFocused : {})
                                }}
                            />
                            {errors.date_of_birth && <div style={errorText}>{errors.date_of_birth}</div>}
                        </div>

                        <div>
                            <label style={fieldLabel}>Highest qualification</label>
                            <select
                                value={form.qualification}
                                onChange={(e) => setForm({ ...form, qualification: e.target.value })}
                                onFocus={() => setFocused("qualification")}
                                onBlur={() => setFocused("")}
                                style={{
                                    ...inputBase,
                                    ...(focused === "qualification" ? inputFocused : {}),
                                    height: 48
                                }}
                            >
                                <option value="">Choose an option</option>
                                <option value="O Level">O Level</option>
                                <option value="A Level">A Level</option>
                                <option value="Foundation">Foundation</option>
                                <option value="Diploma">Diploma</option>
                                <option value="Advanced Diploma">Advanced Diploma</option>
                                <option value="Bachelors">Bachelor's</option>
                                <option value="Masters">Master's</option>
                            </select>
                            {errors.qualification && <div style={errorText}>{errors.qualification}</div>}
                        </div>
                    </div>

                    <button type="submit" style={submitBtn} disabled={loading}>
                        {loading ? <><Spinner size="sm" /> Submitting...</> : "Register Now"}
                    </button>
                </form>
            </div>

            {/* MODAL */}
            <Modal centered show={showModal} onHide={() => hide()}>
                <div style={{ padding: 22, maxWidth: 520, textAlign: "center" }}>
                    <h3 style={{ marginBottom: 6, color: "#0C594F" }}>Notice</h3>
                    <p style={{ color: "#3b4850" }}>{serverMessage}</p>

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 18,
                        marginTop: 16,
                    }}>
                        <a href="https://www.instagram.com/ssie_lk/"><InstagramIcon sx={{ fontSize: 32 }} /></a>
                        <a href="https://web.facebook.com/SSIESriLanka?_rdc=1&_rdr#"><FacebookIcon sx={{ fontSize: 32 }} /></a>
                        <a href="https://www.linkedin.com/company/ssielk"><LinkedInIcon sx={{ fontSize: 32 }} /></a>
                        <a href="https://www.youtube.com/@ACBTSSIE/featured"><YoutubeIcon sx={{ fontSize: 32 }} /></a>
                        <a href="https://ssie.lk/"><LanguageIcon sx={{ fontSize: 32 }} /></a>
                    </div>

                    <Button
                        onClick={() => hide()}
                        style={{ marginTop: 18, width: "100%", background: greenMid, border: "none" }}
                    >
                        Done
                    </Button>

                    <div style={{ marginTop: 12, fontSize: 12, color: "#888" }}>
                        Powered By CrunchTime
                    </div>
                </div>
            </Modal>

            <style>
                {`
          @keyframes scrollLogos {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
            </style>
        </div>
    );
}
